import { injectable } from "inversify";
import type { ISeoFilterState } from "@studyportals/fawkes/scholarships-search-seo";
import { FilterKey } from "@studyportals/search-filters";
import { FilterSelection } from "./FilterSelection";

@injectable()
export class FilterSelectionForIndex implements ISeoFilterState {

	private filterSelection: FilterSelection;

	public constructor(filterSelection: FilterSelection) {
		this.filterSelection = filterSelection;
	}

	public getSelectedValuesFor(key: FilterKey): readonly string[] {
		return this.filterSelection.getFor(key);
	}

	public getSelectedFilters(): readonly FilterKey[] {
		return this.filterSelection.getKeys();
	}
}
